import React from "react";
import { useNavigate } from "react-router-dom";
import { ShieldOff } from "lucide-react";
import StatusPage from "../statusPage/StatusPage";
import { clearAuth } from "../../utill/auth";

// Rendered when the route-level `Gated` guard finds the current user lacks the
// required role/verb. Distinct from 404 — the path exists, but this user is not
// allowed to load it. Used to render NotFound here, which was misleading.
//
// The "Sign in as a different user" secondary action clears the local session and
// routes to /login, which is what an admin / support agent who landed on the
// wrong account expects.

const Forbidden = () => {
  const navigate = useNavigate();

  const switchAccount = () => {
    clearAuth();
    navigate("/login", { replace: true });
  };

  return (
    <StatusPage
      code="403"
      tone="warning"
      Icon={ShieldOff}
      title="Access denied"
      message="You don't have permission to view this page. If you think this is a mistake, contact your administrator or sign in with a different account."
      secondaryAction={{ label: "Sign in as different user", onClick: switchAccount }}
      // The path of a 403 is sometimes sensitive (e.g. /admin/internal-roles) — keep it
      // off the screen by default. The router still has it for actual debugging.
      showPath={false}
    />
  );
};

export default Forbidden;
